import { policyTypeLines } from '@ourbranch/lookups';

// Parse enabled coverage lines once at module load.
// Format: { F: true, H: true, A: true, C: true, R: true }
export const enabledPolicyTypes = JSON.parse(import.meta.env.VITE_AVAILABLE_POLICY_TYPES || '{}');

// A policy-type option is offered only when EVERY coverage line it comprises is enabled
// (policyTypeLines from @ourbranch/lookups decomposes bundles, e.g. HA → [H, A]). So enabling
// Auto surfaces monoline Auto but NOT Home & Auto / Condo & Auto. Unknown ids are not offered.
export const isPolicyTypeEnabled = (optionId) => {
  const lines = policyTypeLines[optionId];
  if (!lines) {
    return false;
  }
  return lines.every((line) => enabledPolicyTypes[line] === true);
};

export const checkIsFarmEnvironment = () => enabledPolicyTypes.F === true;
